<template>
  <div>
    <input-qr-scan-model
      v-model="code"
      ref="codeRef"
      label="Tracking"
      @keyupEnter="scanInput"
    ></input-qr-scan-model>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";

export default {
  name: "FakePayment",
  components: {},
  data: () => ({
    code: null,
  }),
  mounted() {},
  methods: {
    async scanInput() {
      if (!this.code) {
        return false;
      }

      const { data } = await httpClient.post("/payment/v1/fake-request", {
        code: this.code,
      });

      this.code = null;

      if (data) {
        this.$vToastify.success("Thành công");
      } else {
        this.$vToastify.error("Thất bại");
      }
    },
  },
};
</script>
